import { href } from "../lib/route";
import { REVIEWING_TITLE, toReviewWords } from "../lib/reviewerSeat";
import { useReviewingDue } from "../routes/useReviewer";

/* THE DASHBOARD'S `Reviewing` CARD (his question 2026-10-11: *"I'm not gonna be in his dashboard?"*). One row per client this
 * account ACTIVELY reviews — the name and `N days to review` — and the row opens `#/reviewing/<client>`. READ-ONLY: built
 * from `reviewer_links()` + `reviewer_sessions()` (+ his own reviews, to know which days are sent); it is NOT a `To do`
 * item (the coach queue stays his clients' alone) and holds no write path. An account that reviews nobody draws NOTHING;
 * invitations stay on the Clients page's `Reviewing` group, where Accept / Decline live. */
export function ReviewingCard({ today }: { today: string }) {
  const state = useReviewingDue(today);
  if (state.status === "loading") return null;
  if (state.status === "error") return <p className="ht-caption reviewing-error" role="alert">Could not load the clients you review: {state.message}</p>;
  if (state.data.length === 0) return null;
  return (
    <section className="queue-card reviewing-card" aria-labelledby="reviewing-dash-title">
      <header className="queue-card-head">
        <h2 id="reviewing-dash-title" className="queue-card-title">{REVIEWING_TITLE}</h2>
      </header>
      <ol className="queue-rows">
        {state.data.map((r) => (
          <li key={r.clientId} className="queue-row is-linked queue-reply">
            <a className="queue-open" href={href({ name: "reviewing", clientId: r.clientId })} aria-label={`${r.name} — ${toReviewWords(r.due)}`} />
            <span className="queue-title">{r.name}</span>
            <span className="queue-workout">{toReviewWords(r.due)}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
